import {Component, OnInit, OnDestroy} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, UserCalendarDay, User} from '../core/core.component';
import {MessageProvider} from '../service/message.service';
import {UserCalendarService} from '../service/userCalendar.service';
import {AppConstants} from '../core/app.constants';
import {Subscription} from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-extrawork-user',
  templateUrl: './extrawork-user.component.html',
  styleUrls: ['./extrawork-user.component.css']
})

export class ExtraworkUserComponent extends BaseComponent implements OnInit, OnDestroy {

  static DIALOG_ID: string = 'UserExtraWorkDialog';
  userContext: UserContext = null;
  user: User = null;
  userExtraDays: UserCalendarDay[] = [];
  errorMessage: string = null;
  loading: boolean = false;
  private subscriptions: Subscription[] = [];

  locale: any = AppConstants.ITA_CALENDAR_CONF;

  dataStraordinario: Date;
  dataStraordinarioMin: Date = new Date(new Date().getTime() - (1000 * 60 * 60 * (24 * 31))); // da 31 giorni prima;
  dataStraordinarioMax: Date = new Date(new Date().getTime() + (1000 * 60 * 60 * (24 * 365))); // ad un anno dopo 

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userCalendarService: UserCalendarService) {
    super(authAccess, router, messageProvider);
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      for (let i = 0; i < this.subscriptions.length; ++i) {
        this.subscriptions[i].unsubscribe();
      }
    }
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.subscriptions[0] = this.userCalendarService.getUserExtraWorkComponentStatus().subscribe(
        user => {
          if (user != null) {
            this.user = user;
            $('#' + ExtraworkUserComponent.DIALOG_ID).modal({backdrop: 'static', keyboard: false});
            this.load();
          } else {
            this.close();
          }
        }
      );
    }
  }

  private load() {
    this.errorMessage = null;
    this.userExtraDays = [];
    this.loading = true;
    this.userCalendarService.getUserCalendarDays(this.userContext.srmToken, this.dataStraordinarioMin, this.dataStraordinarioMax, this.user.id, true).subscribe(
      result => {
        this.userExtraDays = result.days;
        this.loading = false;
      },
      error => {
        this.errorMessage = this.retrieveError(error);
        this.loading = false;
      }
    );
  }

  toggleDay(day: UserCalendarDay) {
    if (day == null) {
      return;
    }
    if (day.workday == false) {
      this.userCalendarService.insert(this.userContext.srmToken, day.date, day.userId, true).subscribe(
        result => {
          day.workday = true;
        },
        error => {
          this.errorMessage = this.retrieveError(error);
        }
      );
    } else {
      this.userCalendarService.delete(this.userContext.srmToken, day.date, day.userId).subscribe(
        result => {
          day.workday = false;
        },
        error => {
          this.errorMessage = this.retrieveError(error);
        }
      );
    }
  }

  insertExtrawork() {
    if (this.dataStraordinario) {
      this.userCalendarService.insert(this.userContext.srmToken, this.dataStraordinario, this.user.id, true).subscribe(
        result => {
          this.dataStraordinario = null;
          this.load();
        },
        error => {
          this.errorMessage = this.retrieveError(error);
        }
      );
    }
  }

  close() {
    $('#' + ExtraworkUserComponent.DIALOG_ID).modal('hide');
    this.user = null;
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/extrawork-user/extrawork-user.component.ts